module.exports = __webpack_public_path__ + "static/media/rappi.200d11f1.JPG";